import type { WritingCategory } from '@/content/registry';
import { WRITING_CATEGORIES } from '@/content/registry';

export const WRITING_CATEGORY_META: Record<
  WritingCategory,
  { label: string; description: string }
> = {
  engineering: {
    label: 'Engineering',
    description:
      'Engineering notes, architecture decisions, and lessons from building production systems.',
  },
  life: {
    label: 'Life',
    description:
      'Retrospectives, remote work reflections, and notes on how I see the world.',
  },
  tech: {
    label: 'Tech',
    description:
      'Engineering deep dives, mental models, and lessons from building distributed systems.',
  },
};

export function isWritingCategory(value: string): value is WritingCategory {
  return (WRITING_CATEGORIES as readonly string[]).includes(value);
}

export function getCategoryLabel(category: WritingCategory): string {
  return WRITING_CATEGORY_META[category].label;
}

export function getCategoryDescription(category: WritingCategory): string {
  return WRITING_CATEGORY_META[category].description;
}
